import React from "react";
import "../../static/css/landingImage.css";

const LandingImage = (props) => {
  return <>{props.titleImg()}</>;
};

export default LandingImage;
